import { render, staticRenderFns } from "./applicationType.vue?vue&type=template&id=01bcb6ae&scoped=true&"
import script from "./applicationType.vue?vue&type=script&lang=js&"
export * from "./applicationType.vue?vue&type=script&lang=js&"
import style0 from "./applicationType.vue?vue&type=style&index=0&id=01bcb6ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bcb6ae",
  null
  
)

export default component.exports